import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { parseOptionalGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useViewDidFocusLogScreenAnalytics } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

import { useSelfFundedOffer } from './ContextProvider/SelfFundedOfferContextProvider';

const ActivationConfirmationScreen = () => {
  const router = useRouter();
  const { offerId, title, subtitle } = useLocalSearchParams<{
    offerId: string;
    title: string;
    subtitle: string;
  }>();
  const dismissToTab = useDismissToRootTab();
  const { analytics } = useSelfFundedOffer();
  const { t: translatedText } = useTranslation('rewards', {
    keyPrefix: 'selfFundedOffers',
  });

  const displayAnalytics = parseOptionalGQLAnalyticsEvent(analytics.display);
  useViewDidFocusLogScreenAnalytics(displayAnalytics);

  const handleViewOfferDetailsAction = () => {
    router.push({
      pathname: '/rewards/self-funded-offers/[offerId]',
      params: {
        offerId: offerId,
        sectionName: 'self_funded_offer',
      },
    });
  };

  const handleBackToCashbackAction = () => {
    dismissToTab(Tabs.CASHBACK);
  };

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
          gestureEnabled: false,
        }}
      />

      <SuccessScreen
        primaryButton={{
          label: translatedText('activatedOffer.viewOfferDetails'),
          onPress: handleViewOfferDetailsAction,
        }}
        secondaryButton={{
          label: translatedText('activatedOffer.backToCashback'),
          onPress: handleBackToCashbackAction,
        }}
        visual="TOGGLE_A"
        titleText={title}
        content={
          <View>
            <BodyBaseText numberOfLines={0} style={styles.contentText}>
              {subtitle}
            </BodyBaseText>
          </View>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  contentText: {
    textAlign: 'center',
  },
});

export default ActivationConfirmationScreen;
